
import {
    SET_DOJO,
    SET_DOJO_ERROR,
    SET_DOJO_LOADING,
  } from "../actionTypes";
  
  const initialState = {
    dojo: [],
    dojoError: null,
    dojoLoading: false
  };
  
  const dojoReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case SET_DOJO:
        return {
          ...state,
          dojo: payload,
        };
      case SET_DOJO_ERROR:
        return {
          ...state,
          dojoError: payload,
        };
  
      case SET_DOJO_LOADING:
        return {
          ...state,
          dojoLoading: payload,
        };
      default:
        return state;
    }
  };
  
  export default dojoReducer;
  